import { render, staticRenderFns } from "./button-base.vue?vue&type=template&id=9710ab32&scoped=true"
import script from "./button-base.vue?vue&type=script&lang=js"
export * from "./button-base.vue?vue&type=script&lang=js"
import style0 from "./button-base.vue?vue&type=style&index=0&id=9710ab32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9710ab32",
  null
  
)

export default component.exports